import { dataToExecData, ExecPrivilegedArgBase, } from '../ExecPrivilegedArgBase.js';
/**
 * @category Contract Exec Arguments
 */
export default class ExecPrivilegedArgVaultSubscribe extends ExecPrivilegedArgBase {
    static fromJSON(params) {
        return new ExecPrivilegedArgVaultSubscribe(params);
    }
    toData() {
        const { params } = this;
        return {
            vault_subaccount_id: params.vaultSubaccountId,
            trader_subaccount_id: params.traderSubaccountId,
            msg: {
                subscribe: params.args,
            },
        };
    }
    toExecData() {
        const { params } = this;
        return dataToExecData(this.toData(), {
            origin: params.origin,
            name: 'VaultSubscribe',
        });
    }
}
